module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"reviews_count":"评论","product_score":"评分"}}')
  delete Component.options._Ctor
}
